import { Alert, Box, Button, Card, CardContent, IconButton, Snackbar, TextField, Typography } from '@mui/material';
import Header from '../../components/Header';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { tokens } from '../../theme';

const AppConfiguration = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const token = localStorage.getItem('token');
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastmessage] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [values, setValues] = useState({
    app_version: '',
    android_version: '',
  });

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: undefined });
  };

  const getData = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/admin/app-configuration`, { headers: { token } });
    const data = await res.json();
    if (data.success) {
      setValues({
        app_version: data.data?.app_version || '',
        android_version: data.data?.android_version || '',
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFieldErrors({});

    if (values.app_version && values.app_version.length > 50) {
      setFieldErrors({ app_version: 'iOS Version must be at most 50 characters.' });
      setOpenToast(true);
      setToastmessage('iOS Version must be at most 50 characters.');
      return;
    }
    if (values.android_version && values.android_version.length > 50) {
      setFieldErrors({ android_version: 'Android Version must be at most 50 characters.' });
      setOpenToast(true);
      setToastmessage('Android Version must be at most 50 characters.');
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_APILINK}/admin/app-configuration`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          token,
        },
        body: JSON.stringify(values),
      });
      const data = await res.json();
      if (data.errors) {
        setFieldErrors(data.errors);
      }
      if (data.message) {
        setOpenToast(true);
        setToastmessage(data.message);
        if (data.success) {
          getData();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenToast(false);
  };

  const action = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseToast}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" rowGap="10px" flexWrap="wrap-reverse">
        <Header title="Configuration" subtitle="iOS and Android version settings for the mobile app" />
      </Box>

      <Alert severity="warning" sx={{ mb: 2, maxWidth: '640px', borderRadius: 2 }}>
        For developers only. Change iOS/Android versions only when releasing a new app build.
      </Alert>

      <Card
        sx={{
          maxWidth: '640px',
          backgroundColor: colors.primary[400],
        }}
      >
        <CardContent>
          <Typography variant="h4" fontWeight="bold" mb="20px">
            App Configuration
          </Typography>

          <form onSubmit={handleFormSubmit}>
            <Box
              style={{
                display: 'grid',
                gap: '16px',
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="iOS Version"
                placeholder="1.2.0"
                onChange={handleChange}
                name="app_version"
                value={values.app_version}
                error={Boolean(fieldErrors.app_version)}
                helperText={fieldErrors.app_version || ''}
                inputProps={{ maxLength: 50 }}
              />

              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Android Version"
                placeholder="1.2.0"
                onChange={handleChange}
                name="android_version"
                value={values.android_version}
                error={Boolean(fieldErrors.android_version)}
                helperText={fieldErrors.android_version || ''}
                inputProps={{ maxLength: 50 }}
              />

              <Button
                type="submit"
                sx={{
                  backgroundColor: colors.blueAccent[700],
                  color: colors.grey[100],
                  width: 'fit-content',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  padding: '10px 30px',
                  '&:hover': {
                    backgroundColor: colors.blueAccent[800],
                  },
                }}
              >
                Save Configuration
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>

      <Snackbar
        open={openToast}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        message={toastMessage}
        action={action}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default AppConfiguration;
